export default __webpack_public_path__ + "static/media/engine-booking.3c2ca5c6.png";